import { createFileRoute, useLocation } from '@tanstack/react-router';
import { isAssistantLogoOnContainer } from '../../shared/utils/isAssistantLogoOnContainer';
import { administratorApi } from '../../features/adminPanel/services/api/administratorApi';
import { assistantKeys } from '../../features/marketplace/services/queries/assistantApiQueries';
import { assistantAPI } from '../../features/marketplace/services/api/assistantAPI';
import { AssistantListModel } from '../../features/marketplace/types';
import { MarketplacePage } from '../../features/marketplace/pages/MarketplacePage';
import { administratorKeys } from '../../features/adminPanel/services/queries/administratorQueries';

export type NavState = { tabIndex?: number };

export const Route = createFileRoute('/_app/assistants')({
  component: RouteComponent,
  loader: async ({ context }) => {
    const assistantList = await context.queryClient.ensureQueryData({
      queryKey: assistantKeys.list(),
      queryFn: () => assistantAPI.listAssistantsAsync(),
      staleTime: Infinity,
    });
    const favoriteAssistants = await context.queryClient.ensureQueryData({
      queryKey: assistantKeys.favorites(),
      queryFn: () => assistantAPI.getFavoriteAssistants(),
      staleTime: Infinity,
    });
    const isUserFunctionalAssistantAdmin =
      await context.queryClient.ensureQueryData({
        queryKey: administratorKeys.param('Function Administrator'),
        queryFn: () =>
          administratorApi.getAdminParameters('Function Administrator'),
        staleTime: Infinity,
      });
    const isUserAdmin = await context.queryClient.ensureQueryData({
      queryKey: administratorKeys.param('Administrator'),
      queryFn: () => administratorApi.getAdminParameters('Administrator'),
      staleTime: Infinity,
    });
    const assistantData: AssistantListModel[] | undefined =
      context.queryClient.getQueryData(assistantKeys.lists());
    if (assistantData) {
      assistantData.forEach((assistant) => {
        if (isAssistantLogoOnContainer(assistant.image)) {
          context.queryClient.ensureQueryData({
            queryKey: assistantKeys.logo(assistant.name),
            queryFn: () => assistantAPI.getAssistantLogo(assistant.name),
            staleTime: Infinity,
          });
        }
      });
    }
    return {
      assistantList,
      favoriteAssistants,
      isUserFunctionalAssistantAdmin,
      isUserAdmin,
    };
  },
});

function RouteComponent() {
  const location = useLocation();
  const { tabIndex } = (location.state as NavState | undefined) ?? {};
  return <MarketplacePage tabIndex={tabIndex} />;
}
